/** 🔥 all type are based on this Enum */
export const WizardResultModes = {
  Default: 'Default',
  BW: 'BW',
} as const;
Object.freeze(WizardResultModes);

export type WizardResultMode = (typeof WizardResultModes)[keyof typeof WizardResultModes];
